import { render, staticRenderFns } from "./ApplicationStatusRow.vue?vue&type=template&id=1bf2f82f&scoped=true&lang=pug&"
import script from "./ApplicationStatusRow.vue?vue&type=script&lang=js&"
export * from "./ApplicationStatusRow.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationStatusRow.vue?vue&type=style&index=0&id=1bf2f82f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2f82f",
  null
  
)

/* custom blocks */
import block0 from "./ApplicationStatusRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports